import React from "react";
import {MultiSelectChipInput} from "~/apps/core/ui/ChipInput/MultiSelectChipInput";
import {humanizeCargoType} from "~/apps/packages/auto-visits/utils";
import {useCargoListOptions} from "~/apps/packages/auto-shipment-orders/hooks";

const CARGO_TYPES: useCargoListOptions["type"] = [
    "Генеральный груз",
    "Насыпной груз",
    "КТК"
];


export type CargoTypeChipInputProps = {
    value?: string[]
    onChange?: (value: string[]) => any
    disabled?: boolean
}


export const CargoTypeChipInput = (props: CargoTypeChipInputProps) => {
    return (
        <MultiSelectChipInput {...props} title="Тип груза" options={
            CARGO_TYPES.map(value => ({
                value: value,
                title: humanizeCargoType(value),
            }))
        }/>
    )
}